import Immutable from 'immutable';
import moment from 'moment';
import _ from 'lodash';
import regionOptionsOfBankruptcySearchFormMap from '../../../../data/regionOptionsOfBankruptcySearchFormMap';
import validations from '../../validations';


export default function validateLocalCourtsInputs(filtersMap) {
  if (!client_code_is_valid()) {
    return {
      messages: ['Please set a valid client code first.'],
    };
  }

  // Check if only allowed fields are entered
  const allowedFields = Immutable.Set([
    'case_no',
    'court_id',
    'filed_from', 'filed_to',
    'last_business_name', 'first_name', 'middle_name', 'party_name',
    'ssntin',
    'case_type',
  ]);

  const extraFields = filtersMap.filter(value => !!value).keySeq().toSet().subtract(allowedFields);
  if (!extraFields.isEmpty()) {
    return {
      messages: ['Local search accepts only Case Number, SSN, Party Name and Date Filed Filters.'],
      fields: extraFields.toJS(),
    };
  }

  // extract fields into variables for convenience
  const {
    court_id, case_no, ssntin, last_business_name, first_name, filed_from, filed_to, party_name,
  } = filtersMap.toJS();

  const messages = [];
  const fields = [];

  // Validate data of individual fields ---------------------------------------
  if (noneOrMoreThanOneRegionSelected(court_id)) {
    return {
      messages: ['Please select exactly one bankruptcy court for region.'],
      fields: ['court_id'],
    };
  }

  if (!specificCourtSelected(court_id)) {
    return {
      messages: ['Selected region can\'t be a Circuit and it has to be specific instead of catchall.'],
      fields: ['court_id'],
    };
  }

  if (ssntin && !validations.SSN_OR_TIN(ssntin)) {
    messages.push('Invalid SSN/TIN.');
    fields.push('ssntin');
  }

  if (party_name && !validations.PARTY_NAME_CASE_TITLE(party_name)) {
    messages.push('Invalid party name.');
    fields.push('party_name');
  }

  // Fail right away if any fields contain invalid data
  if (messages.length > 0) return { messages, fields };


  // Validate Input field combinations ----------------------------------------
  // case_no is good enough
  if (case_no) return;
  // SSN is good enough
  if (ssntin) return;
  // Last and first ok
  if (last_business_name && first_name) return;
  // Last and small enough date range is OK
  if (last_business_name && isDateRange1WeekOrLess(filed_from, filed_to)) return;
  // 1 week date range
  if (isDateRange1WeekOrLess(filed_from, filed_to)) return;


  if (filed_from && !isDateRange1WeekOrLess(filed_from, filed_to)) {
    return {
      messages: ['Date range must be no greater than 1 Week'],
      fields: ['filed_from', 'filed_to'],
    };
  }

  if (last_business_name && !first_name && !isDateRange1WeekOrLess(filed_from, filed_to)) {
    return {
      messages: ['Last / Business Name requires First name or Date Filed Range not greater than 1 week'],
      fields: ['first_name', 'filed_from', 'filed_to'],
    };
  }


  return {
    messages: [
      'Please enter at least one combination:',
      '- Case Number',
      '- Last Name and First Name',
      '- Last / Business Name and Date Filed Range not greater than 1 week',
      '- SSN/TIN',
      '- Date Filed Range not greater than 1 week',
    ],
    fields: ['last_business_name', 'first_name', 'filed_from', 'filed_to', 'ssntin'],
  };
}

function noneOrMoreThanOneRegionSelected(court_id) {
  return !court_id || /,/.test(court_id);
}


function specificCourtSelected(court_id) {
  if (!court_id) return false;
  const regionOptionsOfBankruptcySearchFormMapList = _.map(regionOptionsOfBankruptcySearchFormMap);
  const regionName = regionOptionsOfBankruptcySearchFormMap[court_id];
  if (court_id.split(',').length > 1 || /Circuit/i.test(regionName)) {
    return false;
  }
  for (const key in regionOptionsOfBankruptcySearchFormMapList) {
    const regionNameRegExp = new RegExp(regionName, 'g');
    const instanceOfRegionNames = regionOptionsOfBankruptcySearchFormMapList[key];
    if (instanceOfRegionNames !== regionName && regionNameRegExp.test(instanceOfRegionNames)) {
      return false;
    }
  }


  return true;
}

function isDateRange1WeekOrLess(filed_from, filed_to) {
  // definitely not less than 1 week if not filled in
  if (!filed_from) return false;

  // since nothing can be filed in the future,
  // we consider blank filedTo to be same as TODAY()
  const endDate = filed_to || moment();

  return endDate.diff(filed_from, 'weeks', true) <= 1.0;
}



// WEBPACK FOOTER //
// ./src/components/search/forms/bankruptcySearchForm/validateLocalCourtsInputs.js